<template>
    <app-drawer
        :menus="menus"
        :allow-mini="false"
        :clipped="false"
        :dark="false"
        :floating="true"
        color="transparent"
        :app="false"
    />
</template>

<script>
import { mapGetters } from 'vuex';
import appDrawer from './drawer';

export default {
    name: 'drawer-project-analytics',
    data: () => ({
        mini: true,
    }),
    components: {
        appDrawer,
    },
    computed: {
        ...mapGetters(['profile']),
        allMenus() {
            return [
                {
                    label: 'projects.analytics.timesByUser',
                    icon: 'mdi-timeline-clock',
                    name: 'timesByUser',
                    group: 'projects.analytics.times',
                    position: 'top',
                },
                {
                    label: 'projects.analytics.issuesByUser',
                    icon: 'mdi-account-group',
                    name: 'issuesByUser',
                    group: 'projects.analytics.issues',
                    position: 'top',
                },
                {
                    label: 'projects.analytics.issuesByTrackers',
                    icon: 'mdi-timeline-clock',
                    name: 'issuesByTracker',
                    group: 'projects.analytics.issues',
                    position: 'top',
                },
            ];
        },
        menus() {
            return this.allMenus;
        },
    },
};
</script>
